import React from 'react';
import { useTranslation } from 'react-i18next';

import { InputHandler } from '../../../../../viewer/input-handler';
import { VolumeCalculatorTool } from '../../../../../viewer/tools/volume-calculator-tool';
import { SkyviewContext } from '../../../skyview/skyview-state';
import { ToolIcon } from '../tool-icon';

const VolumeCalculationToolIcon = () => {
  const { t } = useTranslation();
  const { activeTool } = React.useContext(SkyviewContext);

  return (
    <>
      <ToolIcon
        active={activeTool instanceof VolumeCalculatorTool}
        callback={() => InputHandler.instance.setTool('volume-calculator')}
        disabled={false}
        icon={['fal', 'calculator']}
        tooltip={{
          title: t('volumeCalculation.tooltip.title', { ns: 'skyviewToolbar' }),
          text: t('volumeCalculation.tooltip.text', { ns: 'skyviewToolbar' }),
        }}
      />
    </>
  );
};

export { VolumeCalculationToolIcon };
